export default __webpack_public_path__ + "static/media/search.6c95e853.svg";